var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":"map"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }